export const TID = {
  // header
  appTitle: "app-title",
  modeIndicator: "mode-indicator",
  cbHealthDot: "cb-health-dot",

  // demo launcher
  launcherForm: "demo-launcher-form",
  launcherToken: "demo-launcher-token",
  launcherPlayerId: "demo-launcher-player-id",
  launcherOperatorId: "demo-launcher-operator-id",
  launcherCurrency: "demo-launcher-currency",
  launcherBalance: "demo-launcher-balance",
  launcherSubmit: "demo-launcher-submit",

  // game
  gameRoot: "game-root",
  balanceValue: "balance-value",
  playerIdValue: "player-id-value",
  sessionIdValue: "session-id-value",
  launchTokenValue: "launch-token-value",
  selectKara: "select-kara",
  selectKrus: "select-krus",
  betAmount: "bet-amount",
  flipBtn: "flip-btn",
  coinFlipper: "coin-flipper",
  roundIdValue: "round-id-value",
  resultValue: "result-value",
  lastDebitTxn: "last-debit-txn",
  lastCreditTxn: "last-credit-txn",
  debitIdem: "debit-idem-key",
  creditIdem: "credit-idem-key",
  providerIdValue: "provider-id-value",
  gameIdValue: "game-id-value",
  apiStatus: "api-status",
  payoutInfo: "payout-info",
  historyTable: "history-table",
  refreshBalance: "refresh-balance-btn",

  // admin
  adminPasswordInput: "admin-password-input",
  adminLoginBtn: "admin-login-btn",
  adminPanelRoot: "admin-panel-root",
  adminLogoutBtn: "admin-logout-btn",
  modeToggle: "mode-toggle",
  replayDebitBtn: "replay-debit-btn",
  replayCreditBtn: "replay-credit-btn",
  rollbackDebitBtn: "rollback-debit-btn",
  rollbackCreditBtn: "rollback-credit-btn",
  simTimeoutToggle: "sim-timeout-toggle",
  simSessionToggle: "sim-session-toggle",
  simInsufficientToggle: "sim-insufficient-toggle",
  simRetryToggle: "sim-retry-toggle",
  simDelayedCreditInput: "sim-delayed-credit-input",
  simResetBtn: "sim-reset-btn",
  stress100Btn: "stress-100-btn",
  stress1000Btn: "stress-1000-btn",
  stress10000Btn: "stress-10000-btn",
  stressReport: "stress-report",
  certRunBtn: "cert-run-btn",
  certResults: "cert-results",
};
